import React, { useState } from 'react'
import type { MarketplaceJob } from '../../../services/backendService'
import '../styles/BidSubmissionForm.css'

interface QuoteAcceptFormProps {
  job: MarketplaceJob
  isSubmitting?: boolean
  errorMessage?: string | null
  onAccept: (data: { estimatedDays: number; notes: string }) => Promise<void> | void
  onCancel: () => void
}

export const QuoteAcceptForm: React.FC<QuoteAcceptFormProps> = ({
  job,
  isSubmitting = false,
  errorMessage,
  onAccept,
  onCancel
}) => {
  const [formData, setFormData] = useState({
    estimatedDays: '',
    notes: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await onAccept({
      estimatedDays: parseInt(formData.estimatedDays, 10),
      notes: formData.notes
    })
  }

  return (
    <div className="bid-submission-form">
      <button className="btn-back" onClick={onCancel}>
        ← Back
      </button>

      <div className="form-container">
        <h2>Accept Fixed Price Job: {job.title}</h2>

        <div className="pricing-note">
          Fixed price: ${typeof job.fixedPrice === 'number' ? job.fixedPrice.toFixed(2) : '—'}
        </div>

        {job.estimate && (
          <div className="pricing-note">
            Estimated material: {job.estimate.materialGrams?.toFixed(2)} g · print time: {job.estimate.printTimeMinutes} min
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Estimated Manufacturing Days *</label>
            <input
              type="number"
              name="estimatedDays"
              value={formData.estimatedDays}
              onChange={handleChange}
              placeholder="Number of days"
              min="1"
              required
            />
          </div>

          <div className="form-group">
            <label>Notes (Optional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Add any notes about your acceptance (e.g., timeline, quality guarantees)..."
              rows={4}
            />
          </div>

          {errorMessage && <div className="form-error">{errorMessage}</div>}

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Accepting...' : '✓ Accept at Fixed Price'}
            </button>
            <button type="button" className="btn-secondary" onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
